export const mixCloud = "https://www.mixcloud.com/live/GMGTLive1";
export const gmgtStore = "https://shop.gmgt.live";
